import { TimezoneUserPrefPage } from 'src/views/clog/user-preference/timezone'
import pathMap from 'src/paths/pathMap'

class TimezoneUserPrefRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.TZ_USER_PREF_SETTING,
        component: TimezoneUserPrefPage
      },
    ]
  }
}

export default TimezoneUserPrefRoute
